import { css } from '@emotion/core';
import { variables, tokens, singleLineEllipsis, applyFont } from '@domain-group/fe-brary';
var itemHeightMedium = variables.itemHeightMedium,
  global = variables.global;
var colors = tokens.colors,
  typography = tokens.typography;
var smallSize = '42px';
var largeSize = '60px';
var DESKTOP_MENU_WIDTH = '640px';
export var spaceReserver = {
  name: "eag3eq",
  styles: "position:relative;height:auto;"
};
export var autocomplete = /*#__PURE__*/css("background-color:", colors.neutral.surface.default, ";height:100%;border-radius:3px;");
export var disabled = /*#__PURE__*/css("background-color:", colors.neutral.background.default, ";");
export var spinner = /*#__PURE__*/css("> span > span{border-top-color:", colors.neutral.surface.default, ";}");
var _ref = {
  name: "10ganm4",
  styles: "border:none;"
};
var _ref2 = {
  name: "lxn9mv",
  styles: "margin:-1px;"
};
export var inputWrapper = _ref8 => {
  var size = _ref8.size,
    invalid = _ref8.invalid,
    noBorder = _ref8.noBorder;
  return /*#__PURE__*/css("height:100%;display:flex;align-items:center;margin:0;min-height:", smallSize, ";border:1px solid ", invalid ? colors.critical.trim.default : colors.neutral.trim.default, ";", noBorder && _ref, " border-radius:3px;", size === 'large' && /*#__PURE__*/css("min-height:", largeSize, ";"), " &:focus-within{border:1px solid ", colors.neutral.trim.selected, ";> *{", noBorder && _ref2, "}}");
};
var _ref3 = {
  name: "5hicrt",
  styles: "margin-right:12px;"
};
export var itemList = _ref9 => {
  var size = _ref9.size,
    isOpen = _ref9.isOpen,
    singleSelect = _ref9.singleSelect;
  return /*#__PURE__*/css("display:flex;flex-direction:", isOpen && !singleSelect ? 'column' : 'row', ";flex-grow:1;align-items:", isOpen && !singleSelect ? 'flex-start' : 'center', ";justify-content:stretch;padding:8px 6px 8px 16px;gap:4px;overflow:hidden;", size === 'large' && _ref3);
};
export var selectedItems = {
  name: "1mwjkyo",
  styles: "flex-shrink:1;width:auto;"
};
var _ref4 = {
  name: "lxn9mv",
  styles: "margin:-1px;"
};
export var searchButton = _ref10 => {
  var size = _ref10.size,
    noBorder = _ref10.noBorder,
    buttonText = _ref10.buttonText;
  return /*#__PURE__*/css(!noBorder && _ref4, " align-self:flex-start;height:", smallSize, ";min-width:", smallSize, ";width:", buttonText ? 'auto' : smallSize, ";", size === 'large' && /*#__PURE__*/css("padding:18px;height:", largeSize, ";width:", buttonText ? 'auto' : largeSize, ";"));
};
export var message = {
  name: "1uk1gs8",
  styles: "margin:0;"
};
/* stylelint-disable property-no-vendor-prefix */

// Mostly copied from `fe-co-typeahead`
var _ref5 = {
  name: "16a6ayu",
  styles: "display:block;width:0;height:0;margin:0;padding:0;border:0;"
};
export var comboxInput = _ref11 => {
  var isOpen = _ref11.isOpen;
  return isOpen ? /*#__PURE__*/css("width:100%;", applyFont(typography.body), " background:", colors.neutral.surface.default, ";color:", colors.neutral.heavy.default, ";border:0;padding:0;cursor:default;vertical-align:middle;outline:none;-webkit-appearance:none;font-family:inherit;box-shadow:none;overflow:hidden;display:flex;align-items:center;line-height:", itemHeightMedium, "px;&:focus{outline:0;}&::placeholder{", singleLineEllipsis, " color:", colors.neutral.base.default, ";}") : _ref5;
};
export var optionSheetContainer = {
  name: "79elbk",
  styles: "position:relative;"
};
var _ref6 = {
  name: "1hyfx7x",
  styles: "display:none;"
};
export var optionSheet = _ref12 => {
  var isOpen = _ref12.isOpen;
  return isOpen ? /*#__PURE__*/css("width:100%;background:", colors.neutral.surface.default, ";z-index:", global.layerPopout, ";max-height:400px;overflow:auto;position:absolute;top:-1px;max-width:", DESKTOP_MENU_WIDTH, ";border:1px solid ", colors.neutral.trim.selected, ";border-radius:3px;") : _ref6;
};
var _ref7 = {
  name: "1bf7e4w",
  styles: "align-self:flex-start;"
};
export var placeholderIcon = _ref13 => {
  var size = _ref13.size,
    isOpen = _ref13.isOpen;
  return /*#__PURE__*/css("margin:-1px;width:", smallSize, ";height:", smallSize, ";margin-right:-4px;", size === 'large' && /*#__PURE__*/css("margin-left:-12px;height:", largeSize, ";width:", largeSize, ";"), " ", isOpen && _ref7);
};
export var suggestionExtension = {
  name: "1haizvu",
  styles: "padding:8px 16px;"
};
export var closeButton = {
  name: "1872mkf",
  styles: "margin:-6px 0;"
};